module.exports = __webpack_public_path__ + "static/man-reading-tax-documents-mobile.ad188436.webp";